//export const BASE_URL = 'http://localhost:5124';
 export const BASE_URL = 'https://2429-next-integration.brainence.info';